import { apiFetch } from "./client";
import type {
  TurnoIn,
  TurnoOut,
  PagoReservaIn,
  CompletarTurnoResponse,
  PaginatedResponse,
} from "@/types/api";

export function list(params?: { 
  sede_id?: string; 
  desde?: string; 
  hasta?: string; 
  profesional_id?: number | string;
  paciente_dni?: string;
  estado?: string;
  q?: string;
  page?: number;
  limit?: number;
  ordering?: string;
}): Promise<PaginatedResponse<TurnoOut>> {
  const parts = [];
  if (params?.sede_id) parts.push(`sede_id=${params.sede_id}`);
  if (params?.desde) parts.push(`desde=${params.desde}`);
  if (params?.hasta) parts.push(`hasta=${params.hasta}`);
  if (params?.profesional_id) parts.push(`profesional_id=${params.profesional_id}`);
  if (params?.paciente_dni) parts.push(`paciente_dni=${params.paciente_dni}`);
  if (params?.estado) parts.push(`estado=${params.estado}`);
  if (params?.q) parts.push(`q=${encodeURIComponent(params.q)}`);
  if (params?.page) parts.push(`page=${params.page}`);
  if (params?.limit) parts.push(`limit=${params.limit}`);
  if (params?.ordering) parts.push(`ordering=${params.ordering}`);
  
  const qs = parts.length > 0 ? `?${parts.join('&')}` : "";
  return apiFetch<PaginatedResponse<TurnoOut>>(`/pacientes/turnos/${qs}`);
}

export function get(id: string): Promise<TurnoOut> {
  return apiFetch<TurnoOut>(`/pacientes/turnos/${id}/`);
}

export function create(data: TurnoIn): Promise<TurnoOut> {
  return apiFetch<TurnoOut>("/pacientes/turnos/", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function update(id: string, data: Partial<TurnoIn>): Promise<TurnoOut> {
  return apiFetch<TurnoOut>(`/pacientes/turnos/${id}/`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export function remove(id: string): Promise<void> {
  return apiFetch<void>(`/pacientes/turnos/${id}/`, { method: "DELETE" });
}

export function completar(id: string): Promise<CompletarTurnoResponse> {
  return apiFetch<CompletarTurnoResponse>(`/pacientes/turnos/${id}/completar/`, {
    method: "POST",
  });
}

export function pagarReserva(id: string, data: PagoReservaIn): Promise<TurnoOut> {
  return apiFetch<TurnoOut>(`/pacientes/turnos/${id}/pagar-reserva/`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function reservarTurno(turnoId: string): Promise<TurnoOut> {
  return apiFetch<TurnoOut>(`/pacientes/turnos/${turnoId}/reservar/`, {
    method: 'POST',
  })
}
